<template>
    <div>
        <app-toolbar :toolbar="toolbar"></app-toolbar>
        <v-container fluid>
            <v-form id="Store" ref="Store" @submit.prevent="Store">
                <v-card>
                    <!-- <v-card-title>{{ currentYear }}年 休日予定表 《 H R D 》</v-card-title> -->
                    <v-card-title style="display:block;">
                        <center>
                            <v-icon @click="currentYear--" color="primary">mdi-chevron-left-box</v-icon>
                                {{ currentYear }}年 
                            <v-icon @click="currentYear++" color="primary">mdi-chevron-right-box</v-icon>
                            <br>
                            <h6>休日予定表 《 H R D 》</h6>
                        </center>
                    </v-card-title>

                    <v-card-text>
                        <div class="ml-2" style="display: flex; align-items: flex-end; justify-content: space-between; height: 28px;">
                            <v-checkbox v-model="editMode" label="Enable Edit Mode" hide-details class="mt-0" style="display: inline-block;"></v-checkbox>
                            
                            <v-radio-group v-if="editMode == true" v-model="type" mandatory row hide-details style="display: inline-block;">
                                <template v-slot:label><div>Select type : </div></template>
                                <v-radio label="Holiday" value="1" color="success" hide-details></v-radio>
                                <v-radio label="Not a public holiday" value="2" color="orange" hide-details></v-radio>
                            </v-radio-group>
                        </div>

                        <div class="calendar">
                            <div v-for="(month, index) in months" :key="month" class="month">
                                <div style="font-weight: bold; text-align: center;">{{ index + 1 }}年</div>
                                <div class="weeks">
                                    <div class="day" v-for="(dname,i) in daysOftheWeek" :key="i" :style="{'color': dname == '日' ? 'red' : ''}">{{ dname }}</div>
                                </div>
                                <div class="days">
                                    <div
                                        v-for="(day, i) in getDaysInMonth(index)"
                                        :key="i"
                                        class="day"
                                        @click="day.day && editMode == true ? toggleDate(month, day.day) : null"
                                        :style="{
                                            'cursor': day.day && editMode == true ? 'pointer' : 'default',
                                            'border': day.isHoliday == true ? '1px solid black' : '',
                                            'background-color': day.color,
                                            'color': day.dayOfWeek === 0 || day.color == '#CCFFCC' ? 'red' : day.dayOfWeek === 6 || day.color == '#FCD5B4' ? 'blue' : day.dayofWeek == 6 ? 'blue' : ''
                                        }"
                                    >
                                        {{ day.day }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-card-text>
                    <footer style="text-align: center; font-size: small;">
                        LEGEND : 
                        <div class="legend" style="background-color: #CCFFCC;"></div>休み
                        <div class="legend" style="background-color: #FCD5B4;"></div>祝祭日ではありませんが
                    </footer>
                </v-card>
            </v-form>


        </v-container>

        <!-- <v-dialog v-model="dialogStore" persistent>
            <v-form id="Store" ref="Store" @submit.prevent="Store">
                <v-card>
                    <v-card-title> <span class="overline">Add holiday</span></v-card-title>
                    <v-card-text>
                        <div class="ml-2 mt-5">
                            <v-radio-group
                                v-model="type"
                                mandatory
                                row
                                hide-details
                                >
                                <template v-slot:label><div>Select type : </div></template>
                                <v-radio
                                    label="Holiday"
                                    value="1"
                                    color="success"
                                    hide-details
                                ></v-radio>
                                <v-radio
                                    label="Not a public holiday"
                                    value="2"
                                    color="orange"
                                    hide-details
                                ></v-radio>
                            </v-radio-group>
                        </div>

                        <div class="calendar">
                            <div v-for="(month, index) in months" :key="month" class="month">
                                <div style="font-weight: bold; text-align: center;">{{ index + 1 }}年</div>
                                <div class="weeks">
                                    <div class="day" v-for="(dname,i) in daysOftheWeek" :key="i" :style="{'color': dname == '日' ? 'red' : ''}">{{ dname }}</div>
                                </div>
                                <div class="days">
                                    <div
                                        v-for="(day, i) in getDaysInMonth(index)"
                                        :key="i"
                                        class="day"
                                        @click="day.day ? toggleDate(month, day.day) : null"
                                        :style="{
                                            'cursor': day.day ? 'pointer' : 'default',
                                            'border': day.isHoliday == true ? '1px solid black' : '',
                                            'background-color': day.color,
                                            'color': day.isSunday == true ? 'red' : ''
                                        }"
                                    >
                                        {{ day.day }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text type="submit">保存</v-btn>
                        <v-btn text @click="dialogStore = false">キャンセル</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog> -->
        
        <div>
            <v-btn
                v-if="editMode == true"
                color="primary"
                elevation="2"
                fab
                fixed
                right
                @click="store"
                style="margin-right: 60px;"

            >
                <v-icon>mdi-content-save</v-icon>
            </v-btn>

            <v-btn
                v-if="editMode == true"
                color="primary"
                elevation="2"
                fab
                fixed
                right
                @click="getHolidays"
            >
                <v-icon>mdi-restart</v-icon>
            </v-btn>
        </div>
       

        <!-- <app-buttons  
            @toggleDialogDelete="toggleDialogDelete"
            @toggleDialogStore="toggleDialogStore" 
            :selectedData="selectedData"
            :floatButtons="floatButtons"
        > 
        </app-buttons> -->
        <app-footer :items="holidays.length"></app-footer>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Swal from 'sweetalert2'
import ToolbarMenu from '../../modules/ToolbarMenu.vue';
import Footer from '../../modules/Footer.vue';
// import FloatingButtons from '../../modules/FloatingButtons.vue';
export default {
    components: {
        'app-toolbar': ToolbarMenu,
        // 'app-buttons': FloatingButtons,
        'app-footer': Footer
    },

    data() {
        return {
            toolbar: {
                title: 'HRD CALENDAR',
                view: true,
                back: true,
                filter: false,
                master: false,
            },
            // floatButtons:{
            //     add: true,
            //     update: true,
            //     delete: true
            // },
            tempData: {},
            dialogStore: false,
            dialogUpdate: false,
            dialogDelete: false,
            
            editMode: false,
            currentYear : new Date().getFullYear(),
			months: [
				'January', 'February', 'March', 'April',
				'May', 'June', 'July', 'August',
				'September', 'October', 'November', 'December'
			],
			daysOftheWeek: ['日', '月', '火', '水', '木', '金', '土'],
            type: '',
            selectedDates: [],
			holidays : []
        }
    },

    computed: {
        ...mapState([
                'rules',
                // 'viewMode',
                // 'editMode',
                'loggedInUser'
            ]),
    },

    methods: {

        // toggleUpdateDialog(item){
        //     console.log(item)
        //     if(item){
        //         this.tempData = {...item};
        //         this.dialogUpdate = true;
        //     }else{
        //         this.dialogUpdate = false;
        //     }
        // },
        // toggleDialogDelete(val){
        //     console.log(val)
        //     this.dialogDelete = val;
        // },
        // toggleDialogStore(val){
        //     this.dialogStore = val;
        // },

        getHolidays() {
            axios({
                method: "post",
                url: '/api/hrdCalendar/index',
                data: {
                    userID : this.loggedInUser.id
                },
            }).then((res) => {
                // this.activeDates = res.data.filter((item => item.code == this.userInfo.code))
                this.holidays = res.data
                // console.log(this.holidays)
            })
        },

        getDaysInMonth(monthIndex) {
			const daysInMonth = new Date(this.currentYear, monthIndex + 1, 0).getDate()
			const startingDay = new Date(this.currentYear, monthIndex, 1).getDay()

			// Create an array with empty slots for days before the starting day
			const emptyDays = Array.from({ length: startingDay }, () => ({
				day: '',
				color: '',
				isHoliday: false,
				isSunday: false
			}));

			// Create an array with the actual days in the month
			const daysArray = Array.from({ length: daysInMonth }, (_, i) => ({
				day: i + 1,
				color: this.getDayColor(monthIndex + 1, i + 1),
				isHoliday: this.isHoliday(monthIndex + 1, i + 1),
				isSunday: (startingDay + i) % 7 === 0,
                dayofWeek: new Date((this.currentYear + '-' + (monthIndex + 1 ) + '-' + (i + 1))).getDay()
			}));

			// Concatenate the arrays to get the final array of days
            // console.log(daysArray)
			return emptyDays.concat(daysArray)
		},

		getDayColor(month, day) {
			const formattedDate = `${this.currentYear}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`
			const holiday = this.holidays.find(h => h.date === formattedDate)
			return holiday ? holiday.color : ''
		},

		isHoliday(month, day) {
			const formattedDate = `${this.currentYear}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`
			return this.holidays.some(h => h.date === formattedDate)
		},

		toggleDate(month, day) {
			const monthIndex = this.months.indexOf(month) + 1
			const formattedDate = `${this.currentYear}-${monthIndex.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`

			const existingIndex = this.holidays.findIndex(h => h.date === formattedDate)

			if (existingIndex !== -1) {
				// Date exists in holidays array, remove it
				this.holidays.splice(existingIndex, 1)

                const newHoliday = {
                    date: formattedDate,
                    type: this.type,
                    color: this.type == '1' ? '#CCFFCC' : '#FCD5B4',
                    isSelected: 0,
                };
                this.selectedDates.push(newHoliday)
			} else {
				// Date doesn't exist in holidays array, add it
				const newHoliday = {
                    date: formattedDate,
                    type: this.type,
                    color: this.type == '1' ? '#CCFFCC' : '#FCD5B4',
                    isSelected: 1,
                };
				this.holidays.push(newHoliday)
                this.selectedDates.push(newHoliday)

			}
			// console.log(this.holidays)
            this.holidays.sort((a,b)=> (a.date > b.date ? 1 : -1))
		},

        store(){
            if(this.$refs.Store.validate()){
                // console.log(this.holidays)
                axios({
                    method: 'POST',
                    url: '/api/hrdCalendar/store',
                    data: {
                        dates : this.selectedDates,
                        userID : this.loggedInUser.id
                    }
                }).then(() => {
                    this.editMode = false
                    const Toast = Swal.mixin({
                        toast: true,
                        position: "bottom",
                        padding: "10px",
                        showConfirmButton: false,
                        timer: 1600,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.onmouseenter = Swal.stopTimer;
                            toast.onmouseleave = Swal.resumeTimer;
                        }
			        });
                    Toast.fire({
                        icon: 'success',
                        title: 'Saved!'
                    });
                })
            }
        },
    },

    mounted () {
        this.getHolidays()
    },

}
</script>

<style scoped>
.calendar {
  display: flex;
  flex-wrap: wrap;
  padding-top: 7px;
}

.month {
  border: 1px solid #ccc;
  padding: 10px;
  width: calc(100% / 4);
  box-sizing: border-box;
}

.days {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  font-size: small;
}

.day {
  padding: 0px;
  height: 20px;
  text-align: center;
  font-family: "Rubik", sans-serif !important;
}

.weeks {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  font-size: small;
  font-weight: bold;
}

.legend {
    width: 20px;
	height: 15px;
	border: 1px solid;
	margin-right: 5px;
	display: inline-block;
}

.v-btn--fab{
    bottom: 12px;
}
</style>